<!-- eslint-disable -->
<template>


    <!--begin::Advance Table Widget 5-->
    <div class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
            <h3 class="card-title align-items-start flex-column">
                <span class="card-label font-weight-bolder text-dark">Заказы</span>

            </h3>
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body pt-0">

            <div v-if="orders.length === 0" class="text-center mb-10">
               Заказы не найдены!
            </div>

            <div v-if="load" class="text-center mb-10">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>

            <b-form v-else>

                <!--begin::Table-->
                <div class="table-responsive">
                    <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_2">
                        <thead>
                        <tr class="text-uppercase">
                            <th class="pl-0" style="width: 40px">
                                <label class="checkbox checkbox-lg checkbox-inline mr-2">
                                    <input type="checkbox"
                                           v-model="selectAll"
                                    />
                                    <span></span>
                                </label>
                            </th>
                            <th class="pl-0">#</th>
                            <th style="min-width: 120px">Клиент</th>
                            <th style="min-width: 150px">Дата заказа</th>
                            <th style="min-width: 150px">Итого</th>
                            <th style="min-width: 130px">Статус</th>
                            <th class="pr-0 text-right" style="min-width: 160px">Действия</th>
                        </tr>
                        </thead>
                        <tbody>
                        <template v-for="(order, i) in orders">
                            <tr v-bind:key="i">
                                <td class="pl-0 py-6">
                                    <label class="checkbox checkbox-lg checkbox-inline">
                                        <input type="checkbox"
                                               v-model="selected"
                                               :value="order.id"
                                        />
                                        <span></span>
                                    </label>
                                </td>
                                <td class="pl-0">
                                    <router-link :to="{ name: 'OrderDetails', params: {id: order.id}}"
                                                 class="text-primary font-size-lg"
                                                 :class="{'font-weight-bolder' : order.new}"
                                    ><span v-if="Boolean(order.new)" class="label label-lg label-light-success label-inline">{{order.id}}</span>

                                      <span v-else>{{order.id}}</span>

                                    </router-link>
                                </td>
                                <td>
                                    <span v-if="order.client" class="text-dark-75 d-block font-size-lg" :class="{'font-weight-bolder' : order.new}">

                                         <router-link :to="{ name: 'OrderDetails', params: {id: order.id}}">
                                            {{ order.client.name + ' ' + order.client.surname }}
                                        </router-link>

                                    </span>
                                </td>
                                <td>
                                    <span class="text-dark-75 d-block font-size-lg" :class="{'font-weight-bolder' : order.new}">
                                        {{ moment(order.created_at).format('lll') }}
                                    </span>
                                </td>
                                <td>
                                    <span class="text-dark-75 d-block font-size-lg" :class="{'font-weight-bolder' : order.new}">
                                        {{ numberWithSpaces(order.payment.sum) }} <i class="text-dark icon-nm fas fa-ruble-sign"></i>
                                    </span>
                                </td>
                                <td>

                                    <span v-if="order.status.name === 'Обработка'" class="label label-lg label-light-warning label-inline">{{order.status.name}}</span>
                                    <span v-else-if="order.status.name === 'Выполнен'" class="label label-lg label-light-success label-inline">{{order.status.name}}</span>
                                    <span v-else-if="order.status.name === 'Отменен'" class="label label-lg label-light-danger label-inline">{{order.status.name}}</span>
                                    <span v-else class="label label-lg label-light-primary label-inline">{{order.status.name}}</span>

                                </td>
                                <td class="pr-0 text-right">
                                    <router-link :to="{ name: 'OrderDetails', params: {id: order.id}}" class="btn btn-icon btn-light btn-hover-primary btn-sm mr-3">
                                        <i class="fas fa-edit"></i></router-link>

                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <div class="row align-items-center mb-3">
                    <div class="col-lg-12 col-xl-12">
                        <div class="row align-items-center">
                            <div class="col-md-4 my-2 my-md-0">
                                <b-form-select
                                        class="mb-2 mr-sm-2 mb-sm-0"
                                        :value="null"
                                        v-model="actions"
                                >
                                    <option :value="null">Выберите действие</option>
                                    <option value="del">Удалить выбранные в корзину</option>
                                </b-form-select>
                            </div>
                            <div class="col-md-4 my-2 my-md-0">
                                <b-button @click="moreActions" variant="primary">Применить</b-button>
                            </div>

                        </div>
                    </div>
                </div>
                <Paginate :route_link="'Orders'" :filter="filter" />
            </b-form>
            <!--end::Table-->




            
            
        </div>
        <!--end::Body-->


        <b-modal ref="add-order" size="xl" centered hide-footer title="Создать заказ">
            <div v-if="add_order" class="d-block">
                <div class="row align-items-center">
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите Имя" label="Имя:" >
                            <b-form-input v-model.trim="add_order.name" :class="{'is-invalid': $v.add_order.name.$invalid }" required></b-form-input>
                            <div v-if="!$v.add_order.name.required" class="invalid-feedback">Обязательное поле</div>
                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите Фамилию" label="Фамилия:">
                            <b-form-input v-model.trim="add_order.surname" required></b-form-input>

                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите email" label="Email:">
                            <b-form-input v-model.trim="add_order.email" :class="{'is-invalid': $v.add_order.email.$invalid }" required></b-form-input>
                            <div v-if="!$v.add_order.email.required" class="invalid-feedback">Обязательное поле</div>
                            <div v-if="!$v.add_order.email.email" class="invalid-feedback">Введите правильный email </div>
                        </b-form-group>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите Телефон" label="Телефон:">
                            <b-form-input v-model.trim="add_order.phone" :class="{'is-invalid': $v.add_order.phone.$invalid }" required></b-form-input>
                            <div v-if="!$v.add_order.phone.required" class="invalid-feedback">Обязательное поле</div>
                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите город" label="Город:">
                            <b-form-input v-model.trim="add_order.city"  required></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Выберите способ доставки" label="Способ доставки:">
                            <b-form-select v-model="add_order.delivery_type_id" >
                                <template v-for="(type, i) in delivery_types" >
                                    <option v-bind:key="i" :value="type.id">{{type.name}}</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </div>
                </div>

                <b-form-group class="mb-3"
                              description="Введите адрес доставки"
                              label="Адрес:"
                >
                    <b-form-textarea
                            v-model.trim="add_order.address"
                            :class="{'is-invalid': $v.add_order.address.$invalid}"
                    ></b-form-textarea>
                    <div v-if="!$v.add_order.phone.address" class="invalid-feedback">Обязательное поле</div>
                </b-form-group>
            </div>

            <b-button ref="add_option" class="mt-3" variant="outline-primary" block @click="addOrder" >Далее</b-button>

        </b-modal>
        
    </div>
    <!--end::Advance Table Widget 5-->

</template>

<script>
    import { required, email } from 'vuelidate/lib/validators'
    import moment from "moment";
    require('moment/locale/ru');
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {
        ADD_ORDER,
        GET_NEW_ORDER_DETAILS,
        GET_ORDERS,
        MORE_DELETE_ORDERS
    } from "../../../core/services/store/orders.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import Paginate from "../Paginate";
    export default {
        name: "Orders",
        components: {Paginate},
        validations: {
            add_order: {
                name: {required},
                email: {required, email},
                phone: {required},
                address: {required},
            }
        },

        mounted(){
          this.$store.dispatch(SET_BREADCRUMB, [{ title: "Все заказы" }]);
          this.getFilter();
          this.interval()
        },

        computed: {
            ...mapGetters({
                paginate: 'paginateGetters',
                orders: 'gettersOrders',
                load: 'getOrderLoad',
                delivery_types: 'gettersDeliveryTypes',
                errors: 'errorsOrders',
            }),

            selectAll: {
                get: function () {
                    return this.orders ? this.selected.length == this.orders.length : false;
                },
                set: function (value) {
                    var selected = [];

                    if (value) {
                        this.orders.forEach(function (orders) {
                            selected.push(orders.id);
                        });
                    }

                    this.selected = selected;
                }
            }
        },

        data(){
            return{

              polling: null,

                moment:moment,
                selected: [],
                actions: null,
                filter: {
                    to: '50',
                    trashed: false,
                },

                add_order: {
                    name: '',
                    surname: '',
                    email: '',
                    phone: '',
                    city: '',
                    address: '',

                    client_id: '',
                    delivery_type_id: 1,
                    order_status_id: 1,

                    payment: {
                        type: 'Наличными',
                        status: 'Ожидает',
                        sum: 0
                    },

                    payment_id: '',

                    ordered_items: [],

                },


            }
        },

        methods:{
            numberWithSpaces(x){

                if (x){
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                } else {
                    return 0;
                }

            },

            async getFilter(){
                try {
                    await this.$store.dispatch(GET_ORDERS, {'page': this.$route.params.page, 'filter': this.filter});
                    if (this.orders.length === 0 && this.paginate.total > 0){
                        this.$router.push({ name: 'Orders', params: {page: 1}})
                    }
                } catch (e) {
                    this.showAlert('Ошибка загрузки', 'danger', 'toast');
                }
            },

          interval(){
            const get = () => {
              if (this.$route.name === 'Orders'){
                this.getFilter()
              }
            }
            this.polling = setInterval(() => {
              get()
            }, 60000)
          },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            moreActions(){

                if (this.actions === null){

                    this.showAlert('Необходимо выбрать действие', 'warning', 'toast');
                }

                if (this.actions === "del" && this.selected.length > 0 ) {

                    this.$store.dispatch(MORE_DELETE_ORDERS, this.selected)
                        .then(() => {
                            this.getFilter();
                            this.showAlert('Заказы успешно удалены (перемещены в архив)', 'success', 'toast');
                        })
                        .catch(() => {
                            this.showAlert('Ошибка удаления', 'danger', 'toast');
                        })

                } else if (this.actions === "del" && this.selected.length === 0) {
                    this.showAlert('Необходимо выбрать хотя бы один заказ', 'warning', 'toast');
                }
            },


            newOrder(){

                this.$refs['add-order'].show();
                this.$store.dispatch(GET_NEW_ORDER_DETAILS)
            },

            addOrder(){

                this.$store.dispatch(ADD_ORDER, this.add_order)
                    .then((data) => {
                        this.$router.push({ name: 'OrderDetails', params: {id: data.newOrder.id} })
                        this.showAlert('Заказы успешно создан', 'success', 'toast');
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })

            }

        },

      beforeDestroy () {
        clearInterval(this.polling)
      },

        watch: {

            $route: function () {
                this.getFilter()
            },

            "filter.to": function() {
                this.getFilter()
            },
        }
    }
</script>

<style scoped>

</style>